import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-skateboard",
  "use": "icon-si-glyph-skateboard-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-skateboard\" id=\"icon-si-glyph-skateboard\"><title>99</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(0.000000, 5.000000)\" fill=\"#434343\"><path d=\"M15.252,0.268 C14.704,1.221 13.555,1.125 12.274,1.125 L3.699,1.125 C2.383,1.125 1.268,1.193 0.707,0.187 C0.481,-0.219 -0.206,0.000999999977 0.042,0.546 C0.691,1.966 2.088,2.948 3.705,2.948 L12.278,2.948 C13.851,2.949 15.216,2.02 15.888,0.661 C16.172,0.089 15.496,-0.154 15.252,0.268 L15.252,0.268 Z\" class=\"si-glyph-fill\" /><ellipse cx=\"11.984\" cy=\"4.947\" rx=\"0.984\" ry=\"0.947\" class=\"si-glyph-fill\" /><ellipse cx=\"3.97\" cy=\"4.959\" rx=\"0.97\" ry=\"0.959\" class=\"si-glyph-fill\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-skateboard.svg
// module id = zott
// module chunks = 62